module.exports = __webpack_public_path__ + "img/6ar.44d49242.png";